import { calcPrefixFromDate, getDateFromUTCDateStr, dateToUTCString, getLatestDates, betweenDateRange, getUrlTime } from '../helpers/tools';
import SPACECRAFT_DATA from '../data/spacecraft_data';
import SPACECRAFT_DATA_AR from '../../www/assets/data/spacecraft_data_ar';

import VITALS_DATA from '../data/vitals_data';
import VIDEOS_DATA from '../data/videos_data';
import ENTITY_INFO from '../data/entity_info.json';
import { MISSION_TIMES, POI_CATEGORIES,  GMAP_CATEGORIES } from '../config/constants';
import { datasetStore, refsStore, eventsStore, videoStore, poiStore, gmapStore } from './globalState';
import { updateYear, getAllYears } from '../helpers/processEvents';
import { Config } from '../config/config';

import { getAllYearsPoI } from '../helpers/processPoI';
import { getAllYearsGmap } from '../helpers/processGmap';
import ar from '../languages/ar';
import en from '../languages/en';

import moment from 'moment-timezone';
import momenti from 'moment-hijri';

class Content {
	/**
	 * Constructor
	 * @param {object} entityList The list of all entities used to build the index
	 * @private
	 */
	constructor(pioneer) {
		this._pioneer = pioneer;
		this.language = ar;
		// Custom class names
		this._customClass = {
			scientist: 'comparison',
			school_bus: 'comparison',
			astronaut: 'comparison', 
			camel: 'comparison'
		};

		// Custom entity items for specific cases
		this._customEntityInfo = {
			milky_way: {
				name: 'Milky Way',
				id: 'milky_way',
				adjective: 'Outer Solar',
				category: 'Galaxy',
				keywords: ['milky way'],
				weight: 0
			},
			observable_universe: {
				name: 'Observable Universe',
				id: 'observable_universe',
				adjective: 'Outer Solar',
				category: 'Universe',
				keywords: ['observable universe'],
				weight: 0
			},
			scientist: {
				name: ar.Scientist,
				category: 'Comparison Object'
			},
			school_bus: {
				name: ar.School_Bus,
				category: 'Comparison Object'
			},
			astronaut: {
				name: ar.Astronaut,
				category: 'Comparison Object'
			}, camel: {
				name: ar.Camel,
				category: 'Comparison Object'
			},
			none: {
				name: ar.none,
				category: 'Comparison Object'
			}
		};

		this._replacements = {
		};

		// This map translates between the Spacecraft entity name (key)
		// and the external_id field in the MooreBoek missions API.
		// ToDo: incorporate this data into missions_data - #3174.
		this._missionNames = {
			sc_aqua: 'Aqua',
			sc_aura: 'Aura',
			sc_calipso: 'CALIPSO',
			sc_cloudsat: 'CloudSat',
			sc_cygnss_1: 'CYGNSS',
			sc_cygnss_2: 'CYGNSS',
			sc_cygnss_3: 'CYGNSS',
			sc_cygnss_4: 'CYGNSS',
			sc_cygnss_5: 'CYGNSS',
			sc_cygnss_6: 'CYGNSS',
			sc_cygnss_7: 'CYGNSS',
			sc_cygnss_8: 'CYGNSS',
			sc_gpm: 'GPM',
			sc_grace_fo1: 'GRACE-FO1,GRACE-FO2',
			sc_grace_fo2: 'GRACE-FO1,GRACE-FO2',
			sc_grifex: 'GRIFEX',
			sc_hyspiri: 'HyspIRI',
			sc_icesat_2: 'ICESat-2',
			sc_iss: 'ISS',
			sc_jason_3: 'Jason-3',
			sc_landsat_7: 'Landsat7',
			sc_landsat_8: 'Landsat8',
			sc_landsat_9: 'Landsat9',
			sc_nisar: 'NISAR',
			sc_oco_2: 'OCO-2',
			sc_iss_oco_3: 'OCO-3',
			sc_iss_ecostress: 'ECOSTRESS',
			sc_iss_emit: 'EMIT',
			sc_sentinel_6: 'Sentinel6',
			sc_smap: 'SMAP',
			sc_suomi_npp: 'Suomi_NPP',
			sc_swot: 'SWOT',
			sc_terra: 'Terra',
			sc_saudisat_4: 'sc_saudisat_4',
			sc_tropics_01: 'TROPICS-01',
			sc_tropics_03: 'TROPICS-03',
			sc_tropics_05: 'TROPICS-05',
			sc_tropics_06: 'TROPICS-06',
			sc_tropics_07: 'TROPICS-07'
		};

		this._config = window.config ? window.config : {};
		// this._apiData = this._config.apiData ? this._config.apiData : 'https://eyes.jpl.nasa.gov/dev/assets/dynamic/earth/api/';
		this._apiData = this._config.apiData ? this._config.apiData : 'https://ce2s2.caltech.edu';
		this._ce2s2Data = this._config.ce2s2Data ? this._config.ce2s2Data : 'https://ce2s2.caltech.edu';
		this._apiUrl = this._config.apiUrl ? this._config.apiUrl : 'https://climate-vtad-external.client.mooreboeck.com';
		this._eventUrl = this._config.eventUrl ? this._config.eventUrl : 'https://climate.nasa.gov';
		this._poiUrl = this._config.poiUrl ? this._config.poiUrl : 'https://climate.nasa.gov';
		this._gmapUrl = this._config.gmapUrl ? this._config.gmapUrl : 'https://climate.nasa.gov';

		/**
		 * The list of all entities.
		 * @type {object}
		 * @private
		 */
		this._entityList = null;

		this.eventYears = null;
		this.latestEvents = null;

		/**
		 * The list of all vital signs.
		 * @type {object}
		 * @private
		 */
		this._vitalList = null;

		/**
		 * The object with the dataset manfiests for each dataset.
		 * @type {object}
		 * @public
		 */
		this.datasetsManifest = null;

		/**
		 * Current vital sign data object.
		 * @type {object}
		 * @public
		 */
		this.vitalData = null;

		/**
		 * Current vital sign name id.
		 * @type {string}
		 * @public
		 */
		this.vitalSignId = null;

		/**
		 * Current vital sign index.
		 * @type {number}
		 * @public
		 */
		this.vsIndex = null;

		/**
		 * Whether current vital sign is satellites Now.
		 * @type {boolean}
		 * @public
		 */
		this.isSatellitesNow = null;

		/**
		 * The list of all missions.
		 * @type {object}
		 * @private
		 */
		this._missionList = null;
		/**
		 * The list of all vital signs.
		 * @type {object}
		 * @private
		 */
		this._eventList = null;
		this.language = null;
		/**
		 * The list of all points of interests.
		 * @type {object}
		 * @private
		 */
		this._poiList = null;
		this._gmapList = null;
		this.language = null;
		this.getEventInfo = this.getEventInfo.bind(this);
		this.getPoIInfo = this.getPoIInfo.bind(this);
		this.getGmapInfo = this.getGmapInfo.bind(this);

		// UGH this is the source of that weird truish statement since the events are already set and this is trying to reset them but we don't need it to cuz we already have all the events
		// eventsStore.subscribeTo('yearIndex', async yearIndex => {
		// 	const snapshot = eventsStore.stateSnapshot;
		// 	const events = snapshot.events;
		//   let new_events = {...events}
		// 	const data = await this.getEventsByYear(this.eventYears[yearIndex]);

		// 	if (data && this.eventYears && this.eventYears[yearIndex]) {
		// 		const key = parseInt(this.eventYears[yearIndex]);
		// 		new_events[key] = data;
		//     // console.log("eventStoreSubscribe", events, new_events)
		// 		eventsStore.setGlobalState({ events: new_events });
		// 	}
		// });
	}

	async init() {
		// Download the entity list
		this._entityList = ENTITY_INFO;
		const URL_TIME = Date.now() / (1000 * 60 * 30);

		this._vitalList = VITALS_DATA;
		this._videoList = VIDEOS_DATA;

		const theOrder = [
			'satellites',
			'visible_earth',
			'air_temperature',
			'carbon_dioxide',
			'carbon_monoxide',
			'precipitation',
			'sea_level',
			'soil_moisture',
			'salinity',
			'ozone',
			'water_vapor',
			'gravity_field_map',
			'nitrous_oxide',
			'nitric_acid',
			'chlorine_monoxide',
			'hydrochloric_acid'
		];

		if (this._vitalList) {
			this._vitalList.sort((a, b) => (theOrder.indexOf(a.value) - theOrder.indexOf(b.value)));
		}
		// Download the missions list for earth now missions
		this._missionList = await this._downloadJSON(this._ce2s2Data + '/api/v1/missions/?category=200&per_page=-1');
		const extra = SPACECRAFT_DATA_AR;
		this._missionList = this._missionList.items;
		this._missionList.push(extra.sc_saudisat_4);


		// Await doesn't seem to be needed and saves ~150ms of pausing.
		this.initiateEvents();
		this.initiatePoI();
		this.initiateGmap();
	}

	async initiatePoI() {
		// Download PoI list
		let pois, poiYears;
		try {
			const poiList = await this._downloadJSON('assets/ce2s2_poi/poi.json');
		  pois = poiList.items;
		} catch (e) {
			console.error('PoI List Download: ' + e);
		}

		// console.log("POIs", pois)

		if (pois.length > 0) {
		  poiYears = getAllYearsPoI(pois);
		}

		poiStore.setGlobalState({ pois, poiYears, poi_cats: POI_CATEGORIES, yearIndex: 0, categoryIndex: 0 });
	}

	async initiateGmap() {
		// Download Gmap list
		let gmaps, gmapYears;
		try {
			const gmapList = await this._downloadJSON('assets/ce2s2_gmaps/gmap.json');
			gmaps = gmapList.items;
		} catch (e) {
			console.error('Gmap List Download: ' + e);
		}

		// console.log("GMAPs", gmaps)

		if (gmaps.length > 0) {
		  gmapYears = getAllYearsGmap(gmaps);
		}

		gmapStore.setGlobalState({ gmaps, gmapYears, gmap_cats: GMAP_CATEGORIES, yearIndex: 0, categoryIndex: 0 });
	}

	async initiateEvents() {
		// Download Event list for latest events
		try {
			const URL_TIME = getUrlTime();
			const events_ar = [];
			// get all events
			const eventList = await this._downloadJSON(this._apiData + '/api/v1/earth_now_events/?condition_1=:title_ar:notnull&order=date+desc&per_page=-1');
			this._eventList = eventList.items;
			// break events into two digit year
			eventList.items.map((v, i) => {
				const d = v.date;
				if (v.external_id.indexOf('eo_') == 0) {
					v.external_id = v.external_id.slice(3);
				}
				v.id = `event_${v.id}`;
				const year = d.substring(0, 4);
				if (events_ar[year]) {
					events_ar[year].push(v);
				} else {
					events_ar[year] = [v];
				}
			});
			// console.log("events ar: ", events_ar)
			this._eventYears = Object.keys(events_ar); // this is the old way delete me soon please.
			this.eventYears = Object.keys(events_ar).reverse();
			// set events in eventStore
			// change the year from 2023 to 22024 to update latest event bar
			this.latestEvents = events_ar[2024];
			// this.latestEvents = await this.getEventsByYear(this.eventYears[0]);

			const yearIndex = 0;
			updateYear(yearIndex);
			eventsStore.setGlobalState({ events: events_ar });
		} catch (e) {
			console.error('Event List Download: ' + e);
		}
	}

	/**
	 * Return all the events in the given year
	 * @param {string} year - 2 digits event year
	 * @param {string} key - key for saving events in global state
	 */
	async getEventsByYear(year) {
		if (!year || year.length < 2) {
			console.warn('getEventsByYear: year must be no less than 2 digits', year);
			return null;
		}

		const { events } = eventsStore.stateSnapshot;

		if (!events[year]) {
			const URL_TIME = getUrlTime();

			let data = await this._downloadJSON(`${Config.dynamicAssetsUrl}/earth/eo/event_${year}.json?r=${URL_TIME}`);
			data = data.map(event => ({ ...event, id: event.external_id }));
			data.sort((a, b) => {
				try {
					// converting YYYY-MM-DD to DDMMYYYY. Example: 2023-01-06 to 01062023 for sorting
					const aDate = a.date.split('-')[1] + a.date.split('-')[2] + a.date.split('-')[0];
					const bDate = b.date.split('-')[1] + b.date.split('-')[2] + b.date.split('-')[0];

					if (aDate < bDate) {
						return 1;
					}

					return -1;
				} catch (e) {
					return 0;
				}
			});
			return data;
		}

		return events[year];
	}

	/**
	 * Download a JSON file.
	 * @returns {object}
	 */
	async _downloadJSON(fileName) {
		const accept_language = '*';
		return fetch(fileName, {
			headers: {
				'Accept-Language': accept_language
			}
		}).then(response => response.json());
	}

	/**
	 * Gets the replacement id if it exists.
	 * @param {string} id
	 * @returns {string}
	 */
	getReplacement(id) {
		if (id in this._replacements) {
			id = this._replacements[id];
		}
		return id;
	}

	getEntityInfo(id) {
		id = this.getReplacement(id);
		let entityInfo = {};
		if (id in this._customEntityInfo) {
			entityInfo = this._customEntityInfo[id];
		} else {
			entityInfo = this._entityList[id];
		}
		return entityInfo;
	}

	/**
	 * Gets the entity's id from name.
	 * @param {string} name
	 * @returns {string|null}
	 */
	getCustomEntityId(name) {
		for (const key in this._customEntityInfo) {
			if (this._customEntityInfo[key].name === name) {
				return key;
			}
		}
		return null;
	}

	getClassName(id) {
		id = this.getReplacement(id);
		const entityInfo = this.getEntityInfo(id);

		if (entityInfo === undefined || entityInfo.category === undefined) {
			return id;
		}

		// Add category
		let newClassName = entityInfo.category.toLowerCase().replace(/ /g, '-');
		switch (entityInfo.category) {
			case 'Moon': {
				// Add parent class and id
				const entity = this._pioneer.get('main', id);
				if (entity !== null) {
					// Retrieve parent class if possible
					let parent = entity.getParent();
					while (parent !== null) {
						if (parent.getParent() !== null && parent.getParent().getName() === 'sun') {
							newClassName += ' parent-' + parent.getName() + ' ' + id;
						}
						parent = parent.getParent();
					}
				}
				break;
			}
			default:
				// Just add id
				newClassName += ' ' + id;
				break;
		}

		// Add custom class if it exists
		if (id in this._customClass) {
			newClassName += ' ' + this._customClass[id];
		}

		return newClassName;
	}

	get vitalList() {
		return this._vitalList;
	}

	get videoList() {
		return this._videoList;
	}

	get missionList() {
		return this._missionList;
	}

	get eventList() {
		return this._eventList;
	}

	get poiList() {
		return this._poiList;
	}

	get gmapList() {
		return this._gmapList;
	}

	// get eventYears() {
	// return this._eventYears;
	// }

	get poiYears() {
		return this._poiYears;
	}

	get gmapYears() {
		return this._gmapYears;
	}

	/**
	 * Gets the mission's name from id.
	 * @param {string} id
	 * @returns {string|null}
	 */
	getMissionName(id) {
		return this._missionNames[id] || null;
	}

	/**
	 * Gets the mission's id from name.
	 * @param {string} name
	 * @returns {string|null}
	 */
	getMissionId(name) {
		for (const key in this._missionNames) {
			if (this._missionNames[key] === name) {
				return key;
			}
		}
		return null;
	}

	/**
	 * Gets the vital data by the passed vital sign name id
	 * @param {*} vitalSignId
	 */
	getVitalDataByName(vitalSignId) {
		return this._vitalList.find(vitalDataItem => vitalDataItem.value === vitalSignId);
	}

	getVSIndex(vs) {
		for (let i = this._vitalList.length - 1; i >= 0; i--) {
			if (this._vitalList[i].value === vs) {
				return i;
			}
		}
		return null;
	}

	isValidVS(name) {
		if (!name) {
			return false;
		}
		for (let i = this._vitalList.length - 1; i >= 0; i--) {
			if (this._vitalList[i].value === name) {
				return true;
			}
		}
		return false;
	}

	/**
	 * getEventInfo returns the event referenced by id
	 * @param {string} id
	 */
	getEventInfo(id) {
		if (id === undefined || !this.eventYears) {
			return {};
		}

		const { events } = eventsStore.stateSnapshot;
		// console.log("getEventInfo",id)

		try {
			for (const key in events) {
				const data = events[key];
				if (id.includes('event_')) {
					for (let i = 0; i < data.length; i++) {
						const event = data[i];
						if (event.external_id === id) {
							return event;
						}
					}
				}
			}
		} catch (e) {
			console.warn('getEventInfo warning: ', id, e);
		}

		return {};
	}

	getPoIInfo(id) {
		if (id === undefined || id.indexOf('poi_') < 0) {
			return {};
		}
		// console.log("getPoIInfo",id)
		const { pois } = poiStore.stateSnapshot;
		for (let i = 0; i < pois.length; i++) {
			const poi = pois[i];
			if (`poi_${poi.id}` === id) {
				return poi;
			}
		}
		return {};
	}

	getGmapInfo(id) {
		if (id === undefined || id.indexOf('gmap_') < 0) {
			return {};
		}
		// console.log("getGmapInfo",id)
		const { gmaps } = gmapStore.stateSnapshot;
		for (let i = 0; i < gmaps.length; i++) {
			const gmap = gmaps[i];
			if (`gmap_${gmap.id}` === id) {
				return gmap;
			}
		}
		return {};
	}

	getMissionInfo(id) {
		let info = this._missionList.filter(e => e.external_id === id);
		if (info) {
			info = info[0];
		}
		return info;
	}

	removeExternalLinks(text) {
		let noLinkText = null;
		if (text?.includes('<a')) {
			// Remove <a> tag from text
			noLinkText = text.replace(/<\/?a[^>]*>/g, '');
		}
		return noLinkText || text;
	}

	/**
	 * Sets the current vital sign.
	 * @param {string} vitalsign
	 * @returns {object}
	 */
	setVitalSign(vitalsign) {
		// Return if already set.
		if (this.vitalSignId === vitalsign) {
			return;
		}

		this.vitalSignId = vitalsign;
		this.isSatellitesNow = this.vitalSignId === 'satellites';
		this.vsIndex = this.vitalList.findIndex(vital => vital.value === this.vitalSignId);
		this.vitalData = this.vitalList[this.vsIndex];

		// Update the global state.
		datasetStore.setGlobalState({ currentVS: { ...this.vitalData } });

		return this.vitalData;
	}

	/**
	 * Getting event year from the url if possible
	 * @param {string} year - 2 digits event year
	 * @returns {string} year
	 */
	getEventYearFromUrl() {
		let eventYear = null;

		// In case deeplink has an event that is from a previous year
		if (window.location?.hash.includes('event_')) {
			eventYear = window.location.hash.split('event_');
			if (eventYear.length > 1) {
				try {
					eventYear = eventYear[1].split('?');
					eventYear = eventYear[0].slice(0, 2);
				} catch (e) {
					console.warn('Warning in getting the year from url: ', e);
					eventYear = null;
				}
			} else {
				// default is the current year
				eventYear = null;
			}
		}

		return eventYear;
	}

	/**
	 * Downloads a datasets manifest json file if necessary.
	 * Hydrates dynamic data links for vital sign datasets.
	 */
	async hydrateVitalData() {
		// Generate the manifest download promises.
		const manifestPromises = [];

		this.vitalList.forEach(vitalData => {
			vitalData.datasetGroups.forEach(group => {
				group.datasets.forEach(({ externalId }) => {
					// Generate the correct API path to the dataset
					const datasetPath = `${Config.dynamicAssetsUrl}/earth/data/${externalId}`;
					const manifestPromise = fetch(`${datasetPath}/dataset_manifest.json`, { cache: 'no-store' }).then(response => response.json());
					manifestPromises.push(manifestPromise);
				});
			});
		});


		// Let promises async resolve.
		const manifests = await Promise.all(manifestPromises);

		/**
		 * The manifest script determines the 'endDate' by checking the date of the most recent dataset tiles.
		 * There are cases where this is some time in the past, anything from a few days to some months.
		 * The dates, therefore, between today's date, and the 'endDate' would count as missing dates.
		 * These are not included in the dataset_manifest to save on size but can be easily and quickly calculated below.
		 *
		 * In addition, we can determine whether a satellite is returning up-to-date datasets by comparing the
		 * 'generated' date value with the current UTC time.
		 */
		const todayUTC = dateToUTCString(new Date());
		manifests.forEach(manifest => {
			manifest.upToDate = manifest.generated === todayUTC;
		});

		// Create datasets manifest object.
		this.datasetsManifest = Object.fromEntries(manifests.map(({ datasetName, ...otherProps }) => [datasetName, otherProps]));

		// Generate the data links to hydrate the datasets.
		this.vitalList.forEach(vitalData => {
			vitalData.datasetGroups.forEach(group => {
				group.datasets.forEach(currDataset => {
					const { externalId } = currDataset;
					const { frequency, startDate: earliestDate, endDate: latestDate, missingDates } = this.datasetsManifest[externalId];

					const startDate = getDateFromUTCDateStr(earliestDate);
					const endDate = getDateFromUTCDateStr(latestDate);
					// Add start and end dates (todo: does this need to be in ISO format if we're not storing it?) - #3116.
					currDataset.startDate = startDate.toISOString();
					currDataset.endDate = endDate.toISOString();

					const latestDates = getLatestDates({ frequency, startDate, endDate, missingDates }, 1);

					// Create tilesets list from the latest available dates.
					currDataset.latestTileset = latestDates.map(date => ({
						date: date.toISOString(),
						dateObject: date,
						tilePathPrefix: `${externalId}/${calcPrefixFromDate(date)}`,
						cylThumbFile: `${externalId}/${externalId}_thumbnail.png`
					}))[0];
				});
			});
		});
	}


	/**
	 * Returns an array of strings that represent maps and title of datasets related to the missionId.
	 * @param string missionId
	 */
	getRelatedDatasets(missionId) {
		const { get } = refsStore.stateSnapshot;

		const relatedDatasets = [];
		this._vitalList.forEach(vitalData => {
			vitalData.datasetGroups.forEach((dsGroup, index) => {
				// With multiple datasets, they come from the same satellite, so we only need look at the first dataset.
				const dataset = dsGroup.datasets[0];
				const { externalId, title, missionIds } = dataset;
				const related = missionIds.includes(missionId);

				if (related) {
					relatedDatasets.push({
						id: externalId,
						title,
						group: index,
						value: vitalData.value,
						src: get('dataset').getCylThumbSrc(dataset)
					});
				}
			});
		});

		return relatedDatasets;
	}

	getDisplayData({
		view, missionName, vitalsign, altid, altView, event, poi, gmap
	}) {
		const data = {
			category: '',
			title: '',
			subtitle: '',
			date: '',
			descriptions: []
		};

		this.language = ar;

		switch (view) {
			case 'event':
				data.category = this.language.events;
				if (event) {
					data.title = event.title;
					// data.subtitle = moment(event.date).format('MMM DD, YYYY');
					data.subtitle = momenti(event.date).format('iYYYY/iM/iD');
					data.descriptions = [
						{
							title: '',
							text: event.description
						}
					];
				}
				break;
			case 'poi':
				data.category = this.language.poi;
				if (poi) {
					data.title = poi.title;
					// data.subtitle = moment(event.date).format('MMM DD, YYYY');
					data.subtitle = momenti(poi.date).format('iYYYY/iM/iD');
					data.descriptions = [
						{
							title: '',
							text: poi.description
						}
					];
				}
				break;
			case 'poi':
				data.category = this.language.poi;
				if (poi) {
					data.title = poi.title;
					// data.subtitle = moment(event.date).format('MMM DD, YYYY');
					data.subtitle = momenti(poi.date).format('iYYYY/iM/iD');
					data.descriptions = [
						{
							title: '',
							text: poi.description
						}
					];
				}
				break;
			case 'gmap':
				data.category = this.language.gmap;
				if (gmap) {
					data.title = gmap.title;
					// data.subtitle = moment(event.date).format('MMM DD, YYYY');
					data.subtitle = momenti(gmap.date).format('iYYYY/iM/iD');
					data.descriptions = [
						{
							title: '',
							text: gmap.description
						}
					];
				}
				break;
			case 'spacecraft': {
				data.category = this.language.missions;
				data.title = missionName;
				let missionInfo = this.getMissionInfo(missionName);
				const spacecraft_ar = (this._config.acceptLanguage && this._config.acceptLanguage == 'ar') ? SPACECRAFT_DATA_AR : SPACECRAFT_DATA;

				if (!missionInfo && spacecraft_ar[missionName]) { missionInfo = spacecraft_ar[missionName]; }

				if (missionInfo) {
					const {
						title,
						time_in_orbit: subtitle,
						date: launchDate,
						launch_vehicle: launchVehicle,
						launch_location: launchLocation,
						categories,
						description
					} = missionInfo;
					data.title = title;
					if (categories) {
						if (categories.includes('planned')) {
							if (launchDate) {
								data.subtitle = 'الإطلاق المتوقع: ' + launchDate;
							}
						} else {
							if (subtitle) {
								data.subtitle = `${this.language.time_in_orbit}: ${subtitle}`;
							}
						}
					}
					if (launchVehicle) {
						data.descriptions.push({
							title: this.language.launch_vehicle,
							text: launchVehicle
						});
					}
					if (launchLocation) {
						data.descriptions.push({
							title: this.language.launch_location,
							text: launchLocation
						});
					}
					if (description) {
						data.descriptions.push({
							title: `${this.language.more}  ${title}`,
							html: description
						});
					}
				}
				break;
			}
			default: {
				const vsIndex = this.getVSIndex(vitalsign);

				const currentVS = this._vitalList[vsIndex];

				const { get } = refsStore.stateSnapshot;

				const videoManager = get('video');
				const { videoId } = videoStore.stateSnapshot;
				const videoType = videoManager.getVideoType(videoId);
				if (videoType === 'global' || videoType === 'geoLocated') {
					const videoData = videoManager.getVideoLeftPanelContent(videoId);
					data.category = videoData.category;
					data.title = videoData.title;
					data.subtitle = videoData.subtitle;
					data.date = videoData.date;
					data.descriptions = videoData.descriptions;
				} else if(currentVS){
        console.log("current?", currentVS)
        data.title = currentVS.title;
        data.descriptions = [
          {
            title: this.language.more + ' ' + currentVS.title,
            text: currentVS.shortDescription || currentVS.description
          }
        ];

        if (vsIndex > 0) {
          data.category = this.language.vital_signs;
          const visTitle = currentVS.datasetGroups[altid].datasets[altView].title;
          data.subtitle = visTitle;

          data.descriptions.push({
            title: this.language.about_this_dataset,
            text: this.getDynamicData()?.description
          });
        }
      }        
        // else if (currentVS) {
				// 	data.title = currentVS.title;
				// 	data.descriptions = [];
				// 	// data.descriptions = [
				// 	// {
				// 	// title: `${this.language.about} ${title}`,
				// 	// text: vs_ar.length > 0 ? vs_ar[0].description : (currentVS.shortDescription || currentVS.description)
				// 	// }
				// 	// ];

				// 	// when you're NOT looking at a satellite...
				// 	if ('satellites' != currentVS.value) {
				// 		const found = null;
				// 		data.category = this.language.vital_signs;
				// 		const about_title = `${this.language.more} ${currentVS.title}`;
				// 		const about_description = currentVS.description;
				// 		const dataset = currentVS.datasetGroups[altid].datasets[altView];
				// 		const external_id = dataset.externalId;
				// 		// removed this as the translations are now in vital_data.js -RK
				// 		// if (vs_ar.length > 0) {
				// 		// 	vs_ar[0].dataset_groupings.map(v => {
				// 		// 		const found_ar = v.datasets_sorted.filter(w => w.external_id == external_id);
				// 		// 		if (found_ar.length > 0) {
				// 		// 			data.descriptions.push({
				// 		// 				title: about_title,
				// 		// 				text: v.description
				// 		// 			});
				// 		// 			found = found_ar[0];
				// 		// 		}
				// 		// 	});
				// 		// }
				// 		const mainDesc = found ? found.title : about_description
				// 		const visTitle = found ? found.title : dataset.title;
						
				// 		data.subtitle = visTitle;


				// 		data.descriptions.push({
				// 			title: about_title,
				// 			text: this.getDynamicData()?.description
				// 		});
				// 	} /*else if ('satellites' === currentVS.value) {
				// 		data.descriptions.push({
				// 			title: about_title
				// 			text: about_description
				// 		});
				// 	}*/
				// }
				// break;
			}
		}

		return data;
	}

	/**
	 * Get current data on globe dataset, including legacy datasets, based on dataset dates
	 * @returns {object}
	 */
	getDynamicData() {
		const { get } = refsStore.stateSnapshot;
		const { animations, datasetGroup, dataset } = get('dataset');
		const { animationIndex, currentDataset } = datasetStore.stateSnapshot;
    console.log("getDynamicData", currentDataset)
		const legacyDatasets = datasetGroup?.legacyDatasets?.filter(({ externalId }) => externalId === currentDataset.externalId);

		// Check if latest tileset date is within legacy date ranges before returning default subtitle
		if (legacyDatasets) {
			const latestTilesetDate = getDateFromUTCDateStr(dataset?.latestTileset.date);
			const animationDate = animations?.[animationIndex]?.date && getDateFromUTCDateStr(animations[animationIndex].date);

			const currentDate = animationDate || latestTilesetDate;
			for (const legacyDataset of legacyDatasets) {
				const { start, end } = legacyDataset.dateRange;
				const startDate = start ? getDateFromUTCDateStr(start) : null;
				const endDate = end ? getDateFromUTCDateStr(end) : null;

				const isBetweenRange = betweenDateRange(currentDate, startDate, endDate);

				if (isBetweenRange) {
					return legacyDataset;
				}
			}
		}
		return currentDataset || null;
	}

	isClickable(id) {
		id = this.getReplacement(id);
		if (this._entityList[id] !== undefined && this._entityList[id].clickable !== undefined) {
			return this._entityList[id].clickable;
		}
		return false;
	}

	getColorBarInfo(vsIndex, altid, colorBarIndex = 0) {
		let colorBarSrc = '';
		let colorBarText = '';
		if (vsIndex < 2) {
			return {
				colorBarSrc,
				colorBarText
			};
		}
		const currentVS = this._vitalList[vsIndex];
		colorBarSrc = currentVS.dataset_groupings[altid].datasets_sorted[0].colorbar_urls[0];
		if (vsIndex === 2) {
			colorBarSrc = currentVS.dataset_groupings[altid].datasets_sorted[0].colorbar_urls[colorBarIndex];
			colorBarText = this.language.toggle_units;
		}
		return {
			colorBarSrc,
			colorBarText
		};
	}
}

export default Content;
